import { render, staticRenderFns } from "./ModuleRows.vue?vue&type=template&id=1341dce6"
import script from "./ModuleRows.vue?vue&type=script&lang=js"
export * from "./ModuleRows.vue?vue&type=script&lang=js"
import style0 from "./ModuleRows.vue?vue&type=style&index=0&id=1341dce6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports